import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../components/navbar_poc'
import ShapeTwo from '../components/shape-two'
import TeamOne from '../components/team-one'
import Shape from '../components/shape'
import Footer from '../components/footer'
import SEO from '../components/seo'
// import bg1 from '../assets/images/bg.jpg'
import bg1 from '../assets/images/bg-profile.jpg'
import { services_india_evaluation } from '../data'
import aboutImg2 from '../assets/images/education/indiamapculturalmotif.png'
export default function PageIndiaEvaluation() {
  return (
    <>
     <Navbar/> 
     <SEO
  title="India Market Evaluation – Assess Readiness with Pioneer One Global"
  description="Not sure if India is the right next step? Our India Evaluation services help you assess market viability, cost, and fit before you commit."
  url="https://www.pioneeroneglobal.com/india-evaluation"
  image="https://www.pioneeroneglobal.com/images/og-evaluation.jpg"
/>
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="bg-overlay bg-overlay-white"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title">India - Evaluation</h4>
                          <p className="text-muted mb-0">Not Sure If India Is Right for You? We Help You Evaluate — Strategically and Objectively.</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                          <li className="list-inline-item"><Link to="/page-services" className="text-uppercase fw-bold text-dark">Services</Link></li>
                          <li className="list-inline-item">
                              <span className="text-uppercase text-primary fw-bold">Services - India Evaluation</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <ShapeTwo/>

    <section className="section">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">India Evaluation Services</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Before you commit, we help you explore. Our India Evaluation services assess market fit, operational readiness, and regulatory feasibility — giving you a clear picture of whether, how, and when to enter the Indian market. It’s strategic due diligence, customized to your business goals.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {services_india_evaluation.map((item,index)=>{
              let Icon = item.icon
              return(
                  <div className="col-lg-3 col-md-4 col-12 mt-4 pt-2" key={index}>
                      <div className="feature p-3 py-5 rounded text-center">
                          <Icon className="h2 text-primary"/>
                          <div className="content">
                              <h4 className="title mt-3">{item.title}</h4>
                              <p className="text-muted mt-2 mb-0">{item.shortDescription}</p>
                            <Link to={`/page-service-single/${item.id}`}  className="text-dark">Read More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                          </div>
                      </div>
                  </div>
              )
            })}
          </div>
      </div>
      <div className="container mt-100 mt-60">
          <div className="row align-items-center">
              <div className="col-md-5 order-1 order-md-2 text-end">
                  <img src={aboutImg2} className="img-fluid shadow-lg rounded-top-pill rounded-bottom-5" alt=""/>
              </div>

              <div className="col-md-7 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="section-title">
                  <h4 className="title mb-4">More Than Market Evaluation</h4>
                            <p className="text-muted para-desc mx-auto">India isn’t just a strategic decision — it’s a mindset shift.</p>
                            
                            <p className="text-muted">At Pioneer One Global, we guide you through the numbers and regulations, but we also help you see India for what it truly is: a civilization shaped by resilience, long-term thinking, and interconnected growth.</p>
                      <p className="text-muted">We help you ask not just “Can we succeed in India?”, but “What can India teach us about succeeding differently?”</p>
                      <p className="text-muted">Our goal is not only to help you assess feasibility — but to lay the philosophical and cultural foundation for building something meaningful.</p>
                      <p className="text-muted"><b>India isn't just a market to enter — it's a context to understand</b></p>

                  </div>
              </div>
          </div>
      </div>
      <div className="container mt-100 mt-60">
          <div className="bg-white rounded p-md-5 p-4 p-sm-0 shadow">
              <div className="row align-items-center">
                  <div className="col-sm-7">
                      <div className="text-sm-start">
                          <h4>Ready to grow with India?</h4>
                       </div>
                  </div>
                                    <div className="col-sm-5 mt-4 mt-sm-0">
                                        <div className="text-sm-end">
                                            <Link to="/contact" className="btn btn-outline-primary"><i className="mdi mdi-phone-outline"></i> Let's talk!</Link>
                                        </div>
                                    </div>
              </div>
          </div>
      </div>
 
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
